import { Flex, Select } from 'antd';
import type { SelectProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { SlaTypeDot } from '@/app/landing/sla/shared/components/SlaTypeDot';

type Option = {
  value: string;
  color: string;
  labelKey: string;
};

type Props = Omit<SelectProps, 'options'> & {
  options: Option[];
  translationPrefix: string;
};

export function SlaLabeledSelect({
  options,
  translationPrefix,
  ...selectProps
}: Props) {
  const { t } = useTranslation('sla');

  return (
    <Select
      {...selectProps}
      options={options.map((option) => ({
        value: option.value,
        label: t(`${translationPrefix}.${option.value}`, option.value),
      }))}
      optionRender={(option) => (
        <Flex align="center" gap={8}>
          <SlaTypeDot
            color={
              options.find((item) => item.value === option.value)?.color ??
              '#94a3b8'
            }
            size={10}
          />
          <span>{option.label}</span>
        </Flex>
      )}
      labelRender={(option) => {
        const match = options.find((item) => item.value === option.value);
        return (
          <Flex align="center" gap={8}>
            <SlaTypeDot color={match?.color ?? '#94a3b8'} size={10} />
            <span>{option.label}</span>
          </Flex>
        );
      }}
    />
  );
}
